export default class alertasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
            "all": '/api/usuarios',
			"id": '/api/usuarios/:id',
            "new": '/api/usuarios',
            "delete": '/api/usuarios/:id',
            "update": '/api/usuarios',
            "password" : '/api/usuarios/password/:id',
            "changepassword" : '/api/usuarios/changepassword/:id'
		};
	}

    getAll(filter){
        let url = this.baseUrl + this.routes.all;
        let config = {
            params : filter
        };
        return this.http.get(url, config);
    }

    getById(objId){
        let idRoute = this.routes.id.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.get(url);
    }

    save(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.post(url, data);
    }
    
    changePassword(data){
        let idRoute = this.routes.changepassword.replace(':id', data._id);
        let url = this.baseUrl + idRoute;
        return this.http.post(url, data);
    }

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }

    sendPassword(objId){
        let idRoute = this.routes.password.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.get(url);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/usuariosService.js